import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Input } from '../../../../../../common/Input';

export function ThresholdSetupTab({ formData, setFormData, errorState }) {
  return (
    <div className="space-y-4">
      <div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm">
        <div className="py-2 border-b border-gray-300">
          <h3 className="font-medium text-gray-700">Range Configuration</h3>
        </div>
        <div className="pb-4 pt-3 space-y-4">
          <Input
            label="Threshold Label"
            placeholder="e.g. VP Finance Level"
            value={formData.label}
            onChange={(e) => setFormData({ ...formData, label: e.target.value })}
            error={errorState.label}
            errorMessage="Label is required"
          />

          <div className="grid grid-cols-2 gap-4">
            <Input
              type="number"
              label="Minimum Amount"
              value={formData.minAmount}
              onChange={(e) => setFormData({ ...formData, minAmount: e.target.value })}
            />
            <Input
              type="number"
              label="Maximum Amount"
              value={formData.maxAmount}
              onChange={(e) => setFormData({ ...formData, maxAmount: e.target.value })}
              error={errorState.amounts}
            />
          </div>

          {errorState.amounts && (
            <div className="flex items-center text-red-500 text-xs mt-1">
              <ErrorOutlineIcon fontSize="inherit" className="mr-1" />
              Maximum amount must be greater than minimum amount.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}